import { BsModalRef } from "ngx-bootstrap/modal";
import { OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-confirmation-modal",
    templateUrl: "./confirmation-modal.component.html",
    imports: [NgClass]
})
export class ConfirmationModalComponent implements OnInit {
  
  @Input() title: string = "Are you sure?";
  @Input() message: string;
  
  @Input() cancelLabel: string = "Cancel";
  @Input() confirmLabel: string = "Confirm";

  @Input() confirmButtonClass: string = "btn-danger";

  public onClose: Subject<boolean>;

  public constructor(public bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.onClose = new Subject();
  }

  confirm() {
    this.bsModalRef.hide();
    this.onClose.next(true);
  }

  cancel() {
    this.bsModalRef.hide();
    this.onClose.next(false);
  }
}
